export const columnDefaultProps = {
  classes: "test-column",
  sort: false,
};
